import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { PreviewSummary } from "@/components/shapes/shared/card-preview-parts";
import { useT } from "@/i18n";
import { framesMemoryMessages } from "@/i18n/messages/frames-memory";
import { useMemoryStore } from "@/stores/memory-store";

/** Memory: its title and how much Denker remembers. No globe mounts. */
export function MemoryCardPreview({ frame, density }: CardPreviewProps) {
  const t = useT(framesMemoryMessages);
  const remembers = useMemoryStore((state) => state.globe?.memory_size ?? null);
  return (
    <PreviewSummary
      frame={frame}
      density={density}
      summary={
        remembers === null
          ? ""
          : remembers === 0
            ? t("remembersNothing")
            : t("remembers", { count: remembers })
      }
    />
  );
}
